import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { HelmetProvider } from 'react-helmet-async'
import type { RouterContext } from '@/router'

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
})

function RootComponent() {
  return (
    <HelmetProvider>
      <Outlet />
    </HelmetProvider>
  )
}
